import type { FaireProductEntity } from "../../entity_types/product";

export const p_rf55zbnhfz: FaireProductEntity = {
  token: "p_rf55zbnhfz",
  type: "product",
  name: "Flower Patch Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1a621179f9239f65597923d0dbf0b8485ebea0f6d01ced51b1a71c986f56f5dd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a03855262e277adc30810a951c9fab39c8dde2f8386fc160cab7914b4b49c64d.jpeg",
    "https://cdn.faire.com/fastly/a1ab4672203c17bf6b213c76ee368eef209f82dafa37426b94ef5ece54bc1905.webp",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:21.386Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
